/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterA = createReactComponent("letter-a", "IconLetterA", [
  ["path", { d: "M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12", key: "svg-0" }],
  ["path", { d: "M7 13l10 0", key: "svg-1" }]
]);

export { IconLetterA as default };
//# sourceMappingURL=IconLetterA.js.map
